import { css } from 'styled-components';
import { getThemeData } from '@hzero-front-ui/core';
var TagStyle = function TagStyle(props) {
  var _getThemeData = getThemeData(props, 'common'),
    infoColor = _getThemeData.infoColor;
  return css([".ant-tag.ant-tag{&.ant-tag-checkable-checked{background-color:", ";}&.ant-tag-checkable:not(.ant-tag-checkable-checked):hover{color:", ";}}"], infoColor, infoColor);
};
export default TagStyle;